import React from "react";
import { CircularProgress } from "@mui/material";

type BlogLoadingProps = {
  label?: string;
};

const BlogLoading = ({ label = "Loading…" }: BlogLoadingProps) => (
  <div className="blog-loading" role="status" aria-live="polite" aria-busy="true">
    <CircularProgress
      size={40}
      thickness={4}
      sx={{ color: "var(--secondary-clr)" }}
      aria-hidden="true"
    />
    <p className="blog-loading__label">{label}</p>
  </div>
);

export default BlogLoading;
